module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": _vm.pageTitle,
      "back-route": "event.index"
    }
  }), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "registration_list",
      "label": "Lista de Inscrições"
    }
  }, [_c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Cód. Inscrição")]), _vm._v(" "), _c('th', [_vm._v("Ref. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Telefone")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Modalidades")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Vencimento")]), _vm._v(" "), _c('th', [_vm._v("Pago")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reports.registrations_list.list), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.modalities))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.due_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.pago ? 'Sim' : 'Não'))])])
  }))])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "registrations",
      "label": "Inscrições por Situação de Pagamento"
    }
  }, [_c('table', {
    staticClass: "custom-table-list reports-table-status"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', [_vm._v("Total")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.totalRegistrations))])]), _vm._v(" "), _vm._l((_vm.reports.registrations), function(item) {
    return _c('td', [_c('div', [_vm._v(_vm._s(item.status_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.total))])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_c('div', [_vm._v("R$ " + _vm._s(_vm._f("currencyEnToBr")(_vm.totalAmountRegistrations)))])]), _vm._v(" "), _vm._l((_vm.reports.registrations), function(item) {
    return _c('td', [_c('div', [_vm._v("R$ " + _vm._s(_vm._f("currencyEnToBr")(item.total_amount)))])])
  })], 2)])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "events",
      "label": "Inscrições por Evento"
    }
  }, [_c('div', {
    staticClass: "modalities-list"
  }, [_c('div', {
    staticClass: "modality-items"
  }, _vm._l((_vm.reports.events), function(item, index) {
    return _c('div', {
      staticClass: "modality-item --small"
    }, [_c('h4', [_vm._v(_vm._s(item.event_title))]), _vm._v(" "), _c('div', [_c('highcharts', {
      key: index,
      attrs: {
        "options": _vm.mountChartSemiCircleOptions(item.registrations)
      }
    })], 1)])
  }))])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "modalities",
      "label": "Participantes por Modalidade"
    }
  }, [_c('div', {
    staticClass: "modalities-list"
  }, [_c('div', {
    staticClass: "modality-items"
  }, _vm._l((_vm.reports.modalities), function(items, index) {
    return _c('div', {
      staticClass: "modality-item"
    }, [_c('h4', [_vm._v(_vm._s(items[0].modality_name))]), _vm._v(" "), _c('div', [_c('highcharts', {
      key: index,
      attrs: {
        "options": _vm.mountChartPieOptions(items)
      }
    })], 1)])
  }))])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "papers_review",
      "label": "Trabalhos por Avaliador"
    }
  }, [_c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Avaliador")]), _vm._v(" "), _c('th', [_vm._v("Graduação")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Total de Avaliações")])])]), _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                        Pesquisar Avaliador:\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchAppraiser),
      expression: "searchAppraiser"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchAppraiser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchAppraiser = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.papersReviewList), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.grade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))])])
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65fb820e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/reports/Reports.vue
// module id = 759
// module chunks = 2